export default {
    text1: 'Open Account for Rewards',
    text2: 'Go to Xing Wealth',
    text3: 'Fosun Wealth x MyLink Offers',
    text4: 'Success',
    text5: 'Failed',
    text6: 'Activity Not Found',
    text7: 'Activity Unpublished',
    text8: 'UIN Not Found',
    text9: 'User Not Found',
    text10: 'Already Claimed',
    text11: 'Not Applicable to Your Account',
}
